import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { formatDateForApiRequest } from "../layout/utils/timeUtils";
import { get } from "lodash";
export default () =>
  Object.freeze({
    getCustomApp: async (appId, userId) => {
      const options = createRequestOptions({ appId, userId });

      const result = await fetch(
        Config.mobileServerUrl + "/GetCustomApp",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getCustomAppTemplate: async (appId) => {
      const options = createRequestOptions({ appId });

      const result = await fetch(
        Config.serverUrl + "/GetCustomAppTemplate",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    addCategoriesToCustomApp: async (customAppId, categoryIDs) => {
      const options = createRequestOptions({ customAppId, categoryIDs });

      const result = await fetch(
        Config.mobileServerUrl + "/AddCategoriesToCustomApp",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    addUserCategoryToCustomApp: async (customAppId, newCategory) => {
      const options = createRequestOptions({ customAppId, newCategory });

      const result = await fetch(
        Config.mobileServerUrl + "/AddUserCategoryToCustomApp",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    editCustomAppCategory: async (customAppId, categoryId, category) => {
      const options = createRequestOptions({
        customAppId,
        categoryId,
        category,
      });

      const result = await fetch(
        Config.mobileServerUrl + "/UpdateCustomAppCategory",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    removeCategoriesFromCustomApp: async (customAppId, categoryIDs) => {
      const options = createRequestOptions({ customAppId, categoryIDs });

      const result = await fetch(
        Config.mobileServerUrl + "/RemoveCategoriesFromCustomApp",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    getCustomAppGoal: async (customAppId) => {
      const options = createRequestOptions({ customAppId });

      const result = await fetch(
        Config.mobileServerUrl + "/GetCustomAppGoal",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    addCustomAppGoal: async (customAppId, goal, startDate, endDate) => {
      const options = createRequestOptions({
        customAppId,
        goal,
        startDate,
        endDate,
      });

      const result = await fetch(
        Config.mobileServerUrl + "/AddCustomAppGoal",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    updateCustomAppGoal: async (
      customAppId,
      goalId,
      goal,
      startDate,
      endDate,
      percentageCompleted
    ) => {
      const options = createRequestOptions({
        customAppId,
        goalId,
        goal,
        startDate,
        endDate,
        percentageCompleted,
      });

      const result = await fetch(
        Config.mobileServerUrl + "/UpdateCustomAppGoal",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    removeCustomAppGoal: async (customAppId, goalId) => {
      const options = createRequestOptions({ customAppId, goalId });

      const result = await fetch(
        Config.mobileServerUrl + "/RemoveCustomAppGoal",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    addCustomAppGoalProgress: async (
      goalId,
      description,
      attachmentList,
      createdByProvider
    ) => {
      const options = createRequestOptions({
        goalId,
        description,
        attachmentList,
        createdByProvider,
      });

      const result = await fetch(
        Config.mobileServerUrl + "/AddCustomAppGoalProgress",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    reorderCustomAppCategories: async (customAppId, categoryIDs) => {
      const options = createRequestOptions({ customAppId, categoryIDs });

      const result = await fetch(
        Config.mobileServerUrl + "/ReorderCustomAppCategories",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    addProgramToCustomApp: async (
      appId,
      cappId,
      programList,
      startDate,
      endDate
    ) => {
      const options = createRequestOptions({
        appId,
        cappId,
        programList,
        startDate,
        endDate,
      });
      const result = await fetch(
        Config.serverUrl + "/AddProgramToCustomApp",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    removeProgramFromCustomApp: async (
      appId,
      cappId,
      programId,
      startDate,
      endDate
    ) => {
      const options = createRequestOptions({
        appId,
        cappId,
        programId,
        startDate: formatDateForApiRequest(startDate),
        endDate: formatDateForApiRequest(endDate),
      });
      const result = await fetch(
        Config.serverUrl + "/RemoveProgramFromCustomApp",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
    updateProgramForCustomApp: async (
      appId,
      customAppId,
      programId,
      currentStartDate,
      currentEndDate,
      startDate,
      endDate
    ) => {
      const options = createRequestOptions({
        appId,
        customAppId,
        programId,
        currentStartDate: formatDateForApiRequest(currentStartDate),
        currentEndDate: formatDateForApiRequest(currentEndDate),
        startDate: formatDateForApiRequest(startDate),
        endDate: formatDateForApiRequest(endDate),
      });
      const result = await fetch(
        Config.serverUrl + "/UpdateAssignedProgram",
        options
      );
      const data = await result.json();
      if (data && data.error) {
        return {
          msg: "failed",
          errorMessage:
            (data.error.description || data.error.summary || "").trim() || null,
        };
      }
      return get(data, "response");
    },
    updateAssignedProgramOrder: async (appId, customAppId, programOrder) => {
      const options = createRequestOptions({
        appId,
        customAppId,
        programOrder,
      });

      const result = await fetch(
        Config.serverUrl + "/UpdateAssignedProgramOrder",
        options
      );
      const response = await result.json();
      return get(response, "response");
    },
  });



// WEBPACK FOOTER //
// ./src/services/customapps.js